import { Component, input, Input } from '@angular/core';
import { ICounter } from '../../shared/interfaces/common.interface';
import { environment } from '../../../environments/environment';
import { convertNum } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-widget-coming-soon',
  standalone: false,
  templateUrl: './widget-coming-soon.component.html',
  styleUrl: './widget-coming-soon.component.scss',
})
export class WidgetComingSoonComponent {


  readonly liveCounter = input<ICounter>({
    _days: 0,
    _hours: 0,
    _minutes: 0,
    _seconds: 0,
    _diff: 0,
  });
  readonly raisedInfo = input<{
    usdRaised: number;
    raisedPercent: string;
    userStaked: number;
    userEthClaimable: number;
    userClaimable: number;
    maxAmount: number;
  }>({
    raisedPercent: '',
    usdRaised: 0,
    userClaimable: 0,
    userEthClaimable: 0,
    userStaked: 0,
    maxAmount: 0,
  });

}
